import { jsx as _jsx } from "react/jsx-runtime";
import { CheckBoxOutlineBlankSharp, CheckBoxSharp } from "@mui/icons-material";
export var MuiCheckbox = {
    defaultProps: {
        icon: _jsx(CheckBoxOutlineBlankSharp, {}),
        checkedIcon: _jsx(CheckBoxSharp, {}),
    },
};
